export const MIN_NO_OF_REFER_INPUTS = 3;
